import React from 'react';
import { useDispatch } from 'react-redux';
import Section from '~/App/shared/components/Layout/Section';
import VerificationForm from '~/App/shared/components/PrivateVerificationForm/';
import { CloseIcon, Spacer, resetButtonStyle } from '@kvdbil/components';
import styled from 'styled-components';
import { useTranslation } from '~/Locale';
import { loginFlowEnd } from '~/App/shared/actions/loginFlowActions';
import {
  RegistrationBox,
  RegistrationContainer,
  RegistrationContent,
  RegistrationFormContainer,
  RegistrationHeading
} from '~/App/shared/components/Auth/Registration/components/RegistrationElements';

const CloseButton = styled.button`
  ${resetButtonStyle}
  display: flex;
  svg {
    font-size: 2rem;
  }
`;

interface Props {
  handleClose?: CallableFunction;
  isBiddingView?: boolean;
  isModal?: boolean;
}

export const VerificationWrapper = ({ isModal, handleClose }: Props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const onClickHandler: React.MouseEventHandler<HTMLButtonElement> = event => {
    event.preventDefault();
    handleClose && handleClose();
    dispatch(loginFlowEnd());
  };

  return (
    <Section spacing={0}>
      <RegistrationContainer>
        <RegistrationBox>
          <RegistrationContent>
            {isModal && (
              <CloseButton onClick={onClickHandler}>
                <CloseIcon />
              </CloseButton>
            )}
            <RegistrationHeading>
              {t('To be able to place a bid you must complete your account')}
            </RegistrationHeading>

            <Spacer />

            <RegistrationFormContainer>
              <VerificationForm handleClose={handleClose} />
            </RegistrationFormContainer>
          </RegistrationContent>
        </RegistrationBox>
      </RegistrationContainer>
    </Section>
  );
};

export default VerificationWrapper;
